import { render, staticRenderFns } from "./CharterRelease.vue?vue&type=template&id=2c76ef16&"
import script from "./CharterRelease.vue?vue&type=script&lang=js&"
export * from "./CharterRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports